import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import UnsettledPayments from './UnsettledPayments';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Unsettled Payments | Admin',
    component: (
      <AdminLayout>
        <UnsettledPayments />
      </AdminLayout>
    ),
  };
}

export default action;
